import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import { storiesNoCoverMessage } from 'components/Composer/Content/Media/coverMessages'
import VideoCoverDialog from 'components/Composer/Content/Media/VideoCoverDialog'
import PPDrawer from 'components/PPDrawer'
import PPSwitch from 'components/PPSwitch'
import { Fragment, useState } from 'react'
import { BRAND_INSTAGRAM, POST_TYPE_STORY } from 'shared/constants'
import { ComposerInstagramPost, LocationInfo } from 'shared/types'
import styles from '../BulkPost.pcss'
import InstagramLocationPicker from '../InstagramLocationPicker'
import { BulkNetworkOptionsProps } from './types'

export function InstagramBulkOptions(props: BulkNetworkOptionsProps) {
  const { post, profiles, recycleSelector } = props
  const data = post.data as ComposerInstagramPost
  const [coverDialogOpen, setCoverDialogOpen] = useState(false)

  // EXPL: Stories are published without a cover image, so a cover set before switching to Story is ignored
  const isStory = data.postType === POST_TYPE_STORY

  const onLocationsChange = (locations: Record<string, LocationInfo | undefined>, applyToAll: boolean) => {
    props.onSelectedIGLocationsChange(post.id, locations, applyToAll)
  }

  const onPostTypeChange = (value: string) => {
    props.onPostTypeChange(post.id, BRAND_INSTAGRAM, value)
  }

  const onCoverChange = (url: string | undefined) => {
    props.onCoverChange(post.id, url)
  }

  return (
    <Fragment>
      {Boolean(post.imageUrl) && (
        <InstagramLocationPicker
          profiles={profiles}
          className={styles.option}
          selectedLocations={data.locations}
          onSelectedLocationsChange={onLocationsChange}
        />
      )}
      <div className={styles.option}>
        <PPSwitch
          selectedValue={data.postType || 'post'}
          options={[{
            value: 'post',
            label: post.videoUrl ? 'Post/Reel' : 'Post'
          }, {
            value: POST_TYPE_STORY,
            label: 'Story'
          }]}
          id="ig-post-type-switch"
          onSelectedValueChange={onPostTypeChange}
        />
      </div>
      {post.videoUrl && (
        <div className={styles.option}>
          {/* The row is dense, so the reason for a disabled picker lives in a tooltip rather
              than inline text. A disabled button swallows pointer events - hence the span. */}
          <Tooltip title={isStory ? storiesNoCoverMessage(['Instagram']) : ''}>
            <span data-testid={`bulk-cover-wrap-${post.id}`}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={isStory}
                data-testid={`btn-bulk-cover-${post.id}`}
                onClick={() => setCoverDialogOpen(true)}
              >
                {data.coverUrl ? 'Change cover' : 'Add cover'}
              </Button>
            </span>
          </Tooltip>
          <PPDrawer
            open={coverDialogOpen}
            title="Instagram cover"
            onClose={() => setCoverDialogOpen(false)}
          >
            {coverDialogOpen && (
              <VideoCoverDialog
                coverUrl={data.coverUrl}
                disableClickAway
                onCoverChange={onCoverChange}
                onClose={() => setCoverDialogOpen(false)}
              />
            )}
          </PPDrawer>
        </div>
      )}
      <div className={styles.option}>{recycleSelector}</div>
    </Fragment>
  )
}
